import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DOCUMENTS_ALL } from 'constants/controllers'

export default new Controller({
  name: 'LegacyDocumentsAllRedirect',
  route: 'corporate/documents/browse/all', // At the time of the multi AOL we only had corporate documents
  controller (Router) {
    const target = url(DOCUMENTS_ALL)
    replaceUrl(target)
  }
})
